import isMobile from 'is-mobile';

const ClientDetect = {
    canTouch(){
        return "createTouch" in document;
    },
    isMobile(){
        return isMobile();
    },
    isTablet(){
        return isMobile({ tablet: true }) && !ClientDetect.isSmallScreen();
    },
    isSmallScreen(){
        return Math.min(window.screen.width,window.screen.height) <= 640;
    }
};
export default ClientDetect;
